import axios from "axios";
import { ENDPOINT, API_KEY, environment } from "./environment";
import {
  API_HEADER,
  decryptData,
  encryptData,
  getHeaderConfig,
} from "../helpers";

function parseDecrypted(decrypted) {
  if (!decrypted) return null;
  let parsed;
  try {
    parsed = JSON.parse(decrypted);
  } catch {
    return decrypted;
  }
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      /* leave as string */
    }
  }
  return parsed;
}

// Request/response trace logging. Off in prod, on in dev and local.
const TRACE = environment !== "prod";

function logRequest(_name, path, body) {
  if (!TRACE) return;
  console.log(`-> POST ${path}`, body ?? null);
}

function logResponse(_name, path, decrypted) {
  if (!TRACE) return;
  console.log(`<- POST ${path}`, decrypted);
}

export async function getAccessTokenAPI() {
  const path = "/app/v1/auth/passKey";
  const URL = `${ENDPOINT}${path}`;
  const config = {
    headers: {
      ...API_HEADER,
      "x-api-key": API_KEY,
    },
  };

  logRequest("getAccessTokenAPI", path, null);
  try {
    const response = await axios.post(URL, "", config);
    if (!response?.data) {
      logResponse("getAccessTokenAPI", path, null);
      return null;
    }
    const parsed = parseDecrypted(decryptData(response.data));
    logResponse("getAccessTokenAPI", path, parsed);
    return parsed;
  } catch (error) {
    console.error("getAccessTokenAPI error:", error);
    return null;
  }
}

export async function adminLoginAPI(payload, accessJWT) {
  const path = "/app/v1/auth/adminLogin";
  logRequest("adminLoginAPI", path, payload);
  try {
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}${path}`,
      encryptData(payload),
      config
    );
    const parsed = parseDecrypted(decryptData(response?.data));
    logResponse("adminLoginAPI", path, parsed);
    return parsed;
  } catch (err) {
    console.error("adminLoginAPI error:", err);
    if (err?.response?.data) {
      try {
        const decryptedErr = parseDecrypted(decryptData(err.response.data));
        logResponse("adminLoginAPI", path, decryptedErr);
        return decryptedErr;
      } catch (decryptErr) {
        console.error("Could not decrypt error response", decryptErr);
      }
    }
    return {
      statusCode: err?.response?.status || 500,
      message:
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong with admin login",
    };
  }
}

export async function generateOtpAPI(payload, accessJWT) {
  const path = "/app/v1/auth/generateOTP";
  logRequest("generateOtpAPI", path, payload);
  try {
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}${path}`,
      encryptData(payload),
      config
    );
    const parsed = parseDecrypted(decryptData(response?.data));
    logResponse("generateOtpAPI", path, parsed);
    return parsed;
  } catch (error) {
    console.error("generateOtpAPI error:", error);
    throw error;
  }
}

export async function verifyOtpAPI(payload, accessJWT) {
  const path = "/app/v1/auth/verify";
  logRequest("verifyOtpAPI", path, payload);
  try {
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}${path}`,
      encryptData(payload),
      config
    );
    const parsed = parseDecrypted(decryptData(response?.data));
    logResponse("verifyOtpAPI", path, parsed);
    return parsed;
  } catch (error) {
    console.error("verifyOtpAPI error:", error);
    throw error;
  }
}
